module.exports = __webpack_public_path__ + "static/media/stp_card_diners.864276f5.png";